<template>
  <button class="CancelButton" :aria-label="ariaLabel">
    <Icon class="CancelButton__icon" iconName="Cancel" />
  </button>
</template>

<script>
import Icon from '@spectee/components/Atoms/IconBase/index.vue';

export default {
  name: 'CancelButton',
  components: { Icon },
  props: {
    ariaLabel: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.CancelButton {
  width: $service-unit * 6;
  height: $service-unit * 6;
  cursor: pointer;
  background-color: $color-white-100;

  & &__icon {
    width: $service-unit * 6;
    height: $service-unit * 6;
    color: $color-gray-50;
  }

  &:hover &__icon {
    color: $color-gray-60;
  }
}
</style>
